import { useQuery } from "@tanstack/react-query";
import { getStockLocationsApi } from "../api/stockLocationsApi";
import type { ChainId } from "@KassaroAB/shared/types/ids";

export const useGetStockLocationsQuery = (chainId: ChainId | null) => {
  return useQuery({
    queryKey: ["chains", chainId, "stockLocations"],
    queryFn: () => getStockLocationsApi(chainId!),
    enabled: !!chainId,
  });
};
